import CustomTabs from '../../components/common/CustomTabs'
import MembershipTab from '../../components/membershipTab'
import GeneralForm from '../../components/forms/entrepriseProfile/generalForm'
import ContactsForm from '../../components/forms/entrepriseProfile/contactsForm'

import { t } from 'i18next'

import TabLoader from '../../components/common/tabLoader'
import useEntrepriseProfile from '../../hooks/pages/entreprise/useEntrepriseProfile'
import { ActiveEnterpriseContext } from '../../context/activeEnterpriseContext'
import { useContext } from 'react'
import { useMediaQuery } from '@mui/material'
import Title from '../../components/common/title'

const EntrepriseProfile = () => {
  const isMobile = useMediaQuery('(max-width:800px)')
  const isSmallMobile = useMediaQuery('(max-width:480px)')
  const { generalTab, contactsTab, membershipTab } = useEntrepriseProfile()
  const { activeEnterprise } = useContext(ActiveEnterpriseContext)
  return (
    <>
      <Title>
        {t('pages.entrepriseProfile.title')}
      </Title>
      <CustomTabs
        list={[
          {
            label: t('pages.entrepriseProfile.tabs.general'),
            element: (
              <TabLoader isLoading={generalTab.isloading}>
                <GeneralForm {...generalTab.generalFormProps} />
              </TabLoader>
            ),
            width: isSmallMobile ? '120px' : isMobile ? '140px' : '176px',
          },
          {
            label: t('pages.entrepriseProfile.tabs.contacts'),
            element: (
              <TabLoader isLoading={contactsTab.isloading}>
                <ContactsForm
                  key={activeEnterprise?.crm_id || ''}
                  {...contactsTab.contactsFormProps}
                />
              </TabLoader>
            ),
            width: isSmallMobile ? '140px' : isMobile ? '160px' : '199px',
          },
          {
            label: t('pages.entrepriseProfile.tabs.membership'),
            element: (
              <TabLoader isLoading={membershipTab.isloading}>
                <MembershipTab data={membershipTab.data} />
              </TabLoader>
            ),
            width: isSmallMobile ? '140px' : isMobile ? '160px' : '199px',
          },
        ]}
      />
    </>
  )
}

export default EntrepriseProfile
